import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { semverExports } from 'vscode/external/vscode-semver/semver.js';
import { Emitter, Event } from 'vscode/vscode/vs/base/common/event';
import { index, firstOrDefault } from 'vscode/vscode/vs/base/common/arrays';
import { ThrottledDelayer, Promises, createCancelablePromise } from 'vscode/vscode/vs/base/common/async';
import { CancellationError, isCancellationError } from 'vscode/vscode/vs/base/common/errors';
import { Disposable, toDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { singlePagePager } from '../../../../base/common/paging.js';
import { ITelemetryService } from 'vscode/vscode/vs/platform/telemetry/common/telemetry.service';
import { WEB_EXTENSION_TAG, EXTENSION_IDENTIFIER_REGEX, isTargetPlatformCompatible } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagement';
import { IExtensionGalleryService } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagement.service';
import { getDefaultIconPath } from 'vscode/vscode/vs/workbench/services/extensionManagement/common/extensionManagement';
import { IWorkbenchExtensionEnablementService, IWorkbenchExtensionManagementService, IExtensionManagementServerService } from 'vscode/vscode/vs/workbench/services/extensionManagement/common/extensionManagement.service';
import { getGalleryExtensionTelemetryData, getLocalExtensionTelemetryData, areSameExtensions, groupByExtension, getGalleryExtensionId } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagementUtil';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { IHostService } from 'vscode/vscode/vs/workbench/services/host/browser/host.service';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { HasOutdatedExtensionsContext, AutoUpdateConfigurationKey, AutoCheckUpdatesConfigurationKey } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensions';
import { SIDE_GROUP, ACTIVE_GROUP } from 'vscode/vscode/vs/workbench/services/editor/common/editorService';
import { IEditorService } from 'vscode/vscode/vs/workbench/services/editor/common/editorService.service';
import { IURLService } from 'vscode/vscode/vs/platform/url/common/url.service';
import { ExtensionsInput } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensionsInput';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { IProgressService } from 'vscode/vscode/vs/platform/progress/common/progress.service';
import 'vscode/vscode/vs/platform/notification/common/notification';
import { INotificationService } from 'vscode/vscode/vs/platform/notification/common/notification.service';
import { joinPath } from 'vscode/vscode/vs/base/common/resources';
import { CancellationToken } from 'vscode/vscode/vs/base/common/cancellation';
import { IStorageService } from 'vscode/vscode/vs/platform/storage/common/storage.service';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';
import { ExtensionIdentifier, isApplicationScopedExtension } from 'vscode/vscode/vs/platform/extensions/common/extensions';
import { ILanguageService } from 'vscode/vscode/vs/editor/common/languages/language';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import { FileAccess } from 'vscode/vscode/vs/base/common/network';
import { IIgnoredExtensionsManagementService } from 'vscode/vscode/vs/platform/userDataSync/common/ignoredExtensions.service';
import { IUserDataAutoSyncService, IUserDataSyncEnablementService } from 'vscode/vscode/vs/platform/userDataSync/common/userDataSync.service';
import { IContextKeyService } from 'vscode/vscode/vs/platform/contextkey/common/contextkey.service';
import { isUndefined, isBoolean, isString } from 'vscode/vscode/vs/base/common/types';
import { IExtensionManifestPropertiesService } from 'vscode/vscode/vs/workbench/services/extensions/common/extensionManifestPropertiesService.service';
import { toExtension, toExtensionDescription } from 'vscode/vscode/vs/workbench/services/extensions/common/extensions';
import { IExtensionService } from 'vscode/vscode/vs/workbench/services/extensions/common/extensions.service';
import { isWeb, language } from 'vscode/vscode/vs/base/common/platform';
import { getLocale } from 'vscode/vscode/vs/platform/languagePacks/common/languagePacks';
import { ILocaleService } from 'vscode/vscode/vs/workbench/services/localization/common/locale.service';
import { TelemetryTrustedValue } from 'vscode/vscode/vs/platform/telemetry/common/telemetryUtils';
import { ILifecycleService } from 'vscode/vscode/vs/workbench/services/lifecycle/common/lifecycle.service';
import { IUserDataProfileService } from 'vscode/vscode/vs/workbench/services/userDataProfile/common/userDataProfile.service';
import { mainWindow } from 'vscode/vscode/vs/base/browser/window';
import { IDialogService } from 'vscode/vscode/vs/platform/dialogs/common/dialogs.service';
import { IUpdateService } from 'vscode/vscode/vs/platform/update/common/update.service';
import { isEngineValid } from 'vscode/vscode/vs/platform/extensions/common/extensionValidator';
import { IUriIdentityService } from 'vscode/vscode/vs/platform/uriIdentity/common/uriIdentity.service';
import { IWorkspaceContextService } from 'vscode/vscode/vs/platform/workspace/common/workspace.service';
import Severity$1 from 'vscode/vscode/vs/base/common/severity';

var Extensions_1, ExtensionsWorkbenchService_1;
const _moduleId = "vs/workbench/contrib/extensions/browser/extensionsWorkbenchService";
let Extension = class Extension {
    constructor(stateProvider, runtimeStateProvider, server, local, gallery, resourceExtensionInfo, galleryService, telemetryService, logService, fileService, productService) {
        this.stateProvider = stateProvider;
        this.runtimeStateProvider = runtimeStateProvider;
        this.server = server;
        this.local = local;
        this.gallery = gallery;
        this.resourceExtensionInfo = resourceExtensionInfo;
        this.galleryService = galleryService;
        this.telemetryService = telemetryService;
        this.logService = logService;
        this.fileService = fileService;
        this.productService = productService;
        this.enablementState = 8 ;
        this.isMalicious = false;
        this.resourceExtension = resourceExtensionInfo?.resourceExtension;
    }
    get type() {
        return this.local ? this.local.type : 1 ;
    }
    get isBuiltin() {
        return this.local ? this.local.isBuiltin : false;
    }
    get isWorkspaceScoped() {
        if (this.local) {
            return this.local.isWorkspaceScoped;
        }
        if (this.resourceExtensionInfo) {
            return this.resourceExtensionInfo.isWorkspaceScoped;
        }
        return false;
    }
    get name() {
        if (this.gallery) {
            return this.gallery.name;
        }
        return this.getManifestFromLocalOrResource()?.name ?? '';
    }
    get displayName() {
        if (this.gallery) {
            return this.gallery.displayName || this.gallery.name;
        }
        return this.getManifestFromLocalOrResource()?.displayName ?? this.name;
    }
    get identifier() {
        if (this.gallery) {
            return this.gallery.identifier;
        }
        if (this.resourceExtension) {
            return this.resourceExtension.identifier;
        }
        return this.local.identifier;
    }
    get uuid() {
        return this.gallery ? this.gallery.identifier.uuid : this.local?.identifier.uuid;
    }
    get publisher() {
        if (this.gallery) {
            return this.gallery.publisher;
        }
        return this.getManifestFromLocalOrResource()?.publisher ?? '';
    }
    get publisherDisplayName() {
        if (this.gallery) {
            return this.gallery.publisherDisplayName || this.gallery.publisher;
        }
        if (this.local?.publisherDisplayName) {
            return this.local.publisherDisplayName;
        }
        return this.publisher;
    }
    get publisherUrl() {
        if (!this.productService.extensionsGallery || !this.gallery) {
            return undefined;
        }
        return joinPath(( (URI.parse(this.productService.extensionsGallery.publisherUrl))), this.publisher);
    }
    get publisherDomain() {
        return this.gallery?.publisherDomain;
    }
    get publisherSponsorLink() {
        return this.gallery?.publisherSponsorLink ? ( (URI.parse(this.gallery.publisherSponsorLink))) : undefined;
    }
    get version() {
        return this.local ? this.local.manifest.version : this.latestVersion;
    }
    get pinned() {
        return !!this.local?.pinned;
    }
    get latestVersion() {
        return this.gallery ? this.gallery.version : this.getManifestFromLocalOrResource()?.version ?? '';
    }
    get description() {
        return this.gallery ? this.gallery.description : this.getManifestFromLocalOrResource()?.description ?? '';
    }
    get url() {
        if (!this.productService.extensionsGallery || !this.gallery) {
            return undefined;
        }
        return `${this.productService.extensionsGallery.itemUrl}?itemName=${this.publisher}.${this.name}`;
    }
    get iconUrl() {
        return this.galleryIconUrl || this.resourceExtensionIconUrl || this.localIconUrl || this.defaultIconUrl;
    }
    get iconUrlFallback() {
        return this.galleryIconUrlFallback || this.resourceExtensionIconUrl || this.localIconUrl || this.defaultIconUrl;
    }
    get localIconUrl() {
        if (this.local && this.local.manifest.icon) {
            return (
                 (FileAccess.uriToBrowserUri(joinPath(this.local.location, this.local.manifest.icon)).toString(true))
            );
        }
        return null;
    }
    get resourceExtensionIconUrl() {
        if (this.resourceExtension?.manifest.icon) {
            return (
                 (FileAccess.uriToBrowserUri(joinPath(this.resourceExtension.location, this.resourceExtension.manifest.icon)).toString(true))
            );
        }
        return null;
    }
    get galleryIconUrl() {
        return this.gallery?.assets.icon ? this.gallery.assets.icon.uri : null;
    }
    get galleryIconUrlFallback() {
        return this.gallery?.assets.icon ? this.gallery.assets.icon.fallbackUri : null;
    }
    get defaultIconUrl() {
        if (this.type === 0  && this.local) {
            if (this.local.manifest && this.local.manifest.contributes) {
                if (Array.isArray(this.local.manifest.contributes.themes) && this.local.manifest.contributes.themes.length) {
                    return (
                         (( (FileAccess.asBrowserUri('vs/workbench/contrib/extensions/browser/media/theme-icon.png'))).toString(true))
                    );
                }
                if (Array.isArray(this.local.manifest.contributes.grammars) && this.local.manifest.contributes.grammars.length) {
                    return (
                         (( (FileAccess.asBrowserUri('vs/workbench/contrib/extensions/browser/media/language-icon.svg'))).toString(true))
                    );
                }
            }
        }
        return getDefaultIconPath();
    }
    get repository() {
        return this.gallery && this.gallery.assets.repository ? this.gallery.assets.repository.uri : undefined;
    }
    get licenseUrl() {
        return this.gallery && this.gallery.assets.license ? this.gallery.assets.license.uri : undefined;
    }
    get supportUrl() {
        return this.gallery && this.gallery.supportLink ? this.gallery.supportLink : undefined;
    }
    get state() {
        return this.stateProvider(this);
    }
    get installCount() {
        return this.gallery ? this.gallery.installCount : undefined;
    }
    get rating() {
        return this.gallery ? this.gallery.rating : undefined;
    }
    get ratingCount() {
        return this.gallery ? this.gallery.ratingCount : undefined;
    }
    get outdated() {
        try {
            if (!this.gallery || !this.local) {
                return false;
            }
            if (this.type === 0  && this.productService.quality === 'stable') {
                return false;
            }
            if (!this.local.preRelease && this.gallery.properties.isPreReleaseVersion) {
                return false;
            }
            if (semverExports.gt(this.latestVersion, this.version)) {
                return true;
            }
            if (this.outdatedTargetPlatform) {
                return true;
            }
        }
        catch (error) {
        }
        return false;
    }
    get outdatedTargetPlatform() {
        return !!this.local && !!this.gallery
            && !["undefined" , "web" ].includes(this.local.targetPlatform)
            && this.gallery.properties.targetPlatform !== "web"
            && this.local.targetPlatform !== this.gallery.properties.targetPlatform
            && semverExports.eq(this.latestVersion, this.version);
    }
    get runtimeState() {
        return this.runtimeStateProvider(this);
    }
    get telemetryData() {
        const { local, gallery } = this;
        if (gallery) {
            return getGalleryExtensionTelemetryData(gallery);
        }
        else if (local) {
            return getLocalExtensionTelemetryData(local);
        }
        else {
            return {};
        }
    }
    get preview() {
        return this.local?.manifest.preview ?? this.gallery?.preview ?? false;
    }
    get preRelease() {
        return !!this.local?.preRelease;
    }
    get isPreReleaseVersion() {
        if (this.local) {
            return this.local.isPreReleaseVersion;
        }
        return !!this.gallery?.properties.isPreReleaseVersion;
    }
    get hasPreReleaseVersion() {
        return !!this.gallery?.hasPreReleaseVersion || !!this.local?.hasPreReleaseVersion;
    }
    get hasReleaseVersion() {
        return !!this.resourceExtension || !!this.gallery?.hasReleaseVersion;
    }
    getLocal() {
        return this.local && !this.outdated ? this.local : undefined;
    }
    async getManifest(token) {
        const local = this.getLocal();
        if (local) {
            return local.manifest;
        }
        if (this.gallery) {
            if (this.gallery.assets.manifest) {
                return this.galleryService.getManifest(this.gallery, token);
            }
            this.logService.error(( localizeWithPath(_moduleId, 0, "Manifest is not found")), this.identifier.id);
            return null;
        }
        if (this.resourceExtension) {
            return this.resourceExtension.manifest;
        }
        return null;
    }
    hasReadme() {
        if (this.local && this.local.readmeUrl) {
            return true;
        }
        if (this.gallery && this.gallery.assets.readme) {
            return true;
        }
        if (this.resourceExtension?.readmeUri) {
            return true;
        }
        return this.type === 0 ;
    }
    async getReadme(token) {
        const local = this.getLocal();
        if (local?.readmeUrl) {
            const content = await this.fileService.readFile(local.readmeUrl);
            return (
                 (content.value.toString())
            );
        }
        if (this.gallery) {
            if (this.gallery.assets.readme) {
                return this.galleryService.getReadme(this.gallery, token);
            }
            this.telemetryService.publicLog('extensions:NotFoundReadMe', this.telemetryData);
        }
        if (this.type === 0 ) {
            return Promise.resolve(`# ${this.displayName || this.name}
**Notice:** This extension is bundled with Visual Studio Code. It can be disabled but not uninstalled.
## Features
${this.description}
`);
        }
        if (this.resourceExtension?.readmeUri) {
            const content = await this.fileService.readFile(this.resourceExtension?.readmeUri);
            return (
                 (content.value.toString())
            );
        }
        return Promise.reject(( (new Error('not available'))));
    }
    hasChangelog() {
        if (this.local && this.local.changelogUrl) {
            return true;
        }
        if (this.gallery && this.gallery.assets.changelog) {
            return true;
        }
        return this.type === 0 ;
    }
    async getChangelog(token) {
        const local = this.getLocal();
        if (local?.changelogUrl) {
            const content = await this.fileService.readFile(local.changelogUrl);
            return (
                 (content.value.toString())
            );
        }
        if (this.gallery?.assets.changelog) {
            return this.galleryService.getChangelog(this.gallery, token);
        }
        if (this.type === 0 ) {
            return Promise.resolve('Please check the [VS Code Release Notes](command:update.showCurrentReleaseNotes) for changes to the built-in extensions.');
        }
        return Promise.reject(( (new Error('not available'))));
    }
    get categories() {
        const { local, gallery, resourceExtension } = this;
        if (local && local.manifest.categories && !this.outdated) {
            return local.manifest.categories;
        }
        if (gallery) {
            return gallery.categories;
        }
        if (resourceExtension) {
            return resourceExtension.manifest.categories ?? [];
        }
        return [];
    }
    get tags() {
        const { gallery } = this;
        if (gallery) {
            return gallery.tags.filter(tag => !tag.startsWith('_'));
        }
        return [];
    }
    get dependencies() {
        const { local, gallery, resourceExtension } = this;
        if (local && local.manifest.extensionDependencies && !this.outdated) {
            return local.manifest.extensionDependencies;
        }
        if (gallery) {
            return gallery.properties.dependencies || [];
        }
        if (resourceExtension) {
            return resourceExtension.manifest.extensionDependencies || [];
        }
        return [];
    }
    get extensionPack() {
        const { local, gallery, resourceExtension } = this;
        if (local && local.manifest.extensionPack && !this.outdated) {
            return local.manifest.extensionPack;
        }
        if (gallery) {
            return gallery.properties.extensionPack || [];
        }
        if (resourceExtension) {
            return resourceExtension.manifest.extensionPack || [];
        }
        return [];
    }
    getManifestFromLocalOrResource() {
        if (this.local) {
            return this.local.manifest;
        }
        if (this.resourceExtension) {
            return this.resourceExtension.manifest;
        }
        return null;
    }
};
Extension = ( (__decorate([
    ( (__param(6, IExtensionGalleryService))),
    ( (__param(7, ITelemetryService))),
    ( (__param(8, ILogService))),
    ( (__param(9, IFileService))),
    ( (__param(10, IProductService)))
], Extension)));
const EXTENSIONS_AUTO_UPDATE_KEY = 'extensions.autoUpdate';
let Extensions = Extensions_1 = class Extensions extends Disposable {
    static updateExtensionFromControlManifest(extension, extensionsControlManifest) {
        extension.isMalicious = ( (extensionsControlManifest.malicious.some(identifier => areSameExtensions(extension.identifier, identifier))));
        extension.deprecationInfo = extensionsControlManifest.deprecated ? extensionsControlManifest.deprecated[extension.identifier.id.toLowerCase()] : undefined;
    }
    get onChange() { return this._onChange.event; }
    get onReset() { return this._onReset.event; }
    constructor(server, stateProvider, runtimeStateProvider, isWorkspaceServer, galleryService, extensionEnablementService, workbenchExtensionManagementService, telemetryService, instantiationService) {
        super();
        this.server = server;
        this.stateProvider = stateProvider;
        this.runtimeStateProvider = runtimeStateProvider;
        this.isWorkspaceServer = isWorkspaceServer;
        this.galleryService = galleryService;
        this.extensionEnablementService = extensionEnablementService;
        this.workbenchExtensionManagementService = workbenchExtensionManagementService;
        this.telemetryService = telemetryService;
        this.instantiationService = instantiationService;
        this._onChange = this._register(( (new Emitter())));
        this._onReset = this._register(( (new Emitter())));
        this.installing = [];
        this.uninstalling = [];
        this.installed = [];
        this._register(server.extensionManagementService.onInstallExtension(e => this.onInstallExtension(e)));
        this._register(server.extensionManagementService.onDidInstallExtensions(e => this.onDidInstallExtensions(e)));
        this._register(server.extensionManagementService.onUninstallExtension(e => this.onUninstallExtension(e.identifier)));
        this._register(server.extensionManagementService.onDidUninstallExtension(e => this.onDidUninstallExtension(e)));
        this._register(server.extensionManagementService.onDidUpdateExtensionMetadata(e => this.onDidUpdateExtensionMetadata(e)));
        this._register(server.extensionManagementService.onDidChangeProfile(() => this.reset()));
        this._register(extensionEnablementService.onEnablementChanged(e => this.onEnablementChanged(e)));
        this._register(Event.any(this.onChange, this.onReset)(() => this._local = undefined));
        if (this.isWorkspaceServer) {
            this._register(this.workbenchExtensionManagementService.onInstallExtension(e => {
                if (e.workspaceScoped) {
                    this.onInstallExtension(e);
                }
            }));
            this._register(this.workbenchExtensionManagementService.onDidInstallExtensions(e => {
                const result = e.filter(e => e.workspaceScoped);
                if (result.length) {
                    this.onDidInstallExtensions(result);
                }
            }));
            this._register(this.workbenchExtensionManagementService.onUninstallExtension(e => {
                if (e.workspaceScoped) {
                    this.onUninstallExtension(e.identifier);
                }
            }));
            this._register(this.workbenchExtensionManagementService.onDidUninstallExtension(e => {
                if (e.workspaceScoped) {
                    this.onDidUninstallExtension(e);
                }
            }));
        }
    }
    get local() {
        if (!this._local) {
            this._local = [];
            for (const extension of this.installed) {
                this._local.push(extension);
            }
            for (const extension of this.installing) {
                if (!( (this.installed.some(installed => areSameExtensions(installed.identifier, extension.identifier))))) {
                    this._local.push(extension);
                }
            }
        }
        return this._local;
    }
    async queryInstalled(productVersion) {
        await this.fetchInstalledExtensions(productVersion);
        this._onChange.fire(undefined);
        return this.local;
    }
    async syncInstalledExtensionsWithGallery(galleryExtensions, productVersion) {
        const extensions = await this.mapInstalledExtensionWithCompatibleGalleryExtension(galleryExtensions, productVersion);
        for (const [extension, gallery] of extensions) {
            if (extension.local && !extension.local.identifier.uuid) {
                extension.local = await this.updateMetadata(extension.local, gallery);
            }
            if (!extension.gallery || extension.gallery.version !== gallery.version || extension.gallery.properties.targetPlatform !== gallery.properties.targetPlatform) {
                extension.gallery = gallery;
                this._onChange.fire({ extension });
            }
        }
    }
    async mapInstalledExtensionWithCompatibleGalleryExtension(galleryExtensions, productVersion) {
        const mappedExtensions = this.mapInstalledExtensionWithGalleryExtension(galleryExtensions);
        const targetPlatform = await this.server.extensionManagementService.getTargetPlatform();
        const compatibleGalleryExtensions = [];
        const compatibleGalleryExtensionsToFetch = [];
        await Promise.allSettled(( (mappedExtensions.map(async ([extension, gallery]) => {
            if (extension.local) {
                if (await this.galleryService.isExtensionCompatible(gallery, extension.local.preRelease, targetPlatform, productVersion)) {
                    compatibleGalleryExtensions.push(gallery);
                }
                else {
                    compatibleGalleryExtensionsToFetch.push({ ...extension.local.identifier, preRelease: extension.local.preRelease });
                }
            }
        }))));
        if (compatibleGalleryExtensionsToFetch.length) {
            const result = await this.galleryService.getExtensions(compatibleGalleryExtensionsToFetch, { targetPlatform, compatible: true, queryAllVersions: true, productVersion }, CancellationToken.None);
            compatibleGalleryExtensions.push(...result);
        }
        return this.mapInstalledExtensionWithGalleryExtension(compatibleGalleryExtensions);
    }
    mapInstalledExtensionWithGalleryExtension(galleryExtensions) {
        const mappedExtensions = [];
        const byUUID = ( (new Map())), byID = ( (new Map()));
        for (const gallery of galleryExtensions) {
            byUUID.set(gallery.identifier.uuid, gallery);
            byID.set(gallery.identifier.id.toLowerCase(), gallery);
        }
        for (const installed of this.installed) {
            if (installed.uuid) {
                const gallery = byUUID.get(installed.uuid);
                if (gallery) {
                    mappedExtensions.push([installed, gallery]);
                    continue;
                }
            }
            if (installed.local?.source !== 'resource') {
                const gallery = byID.get(installed.identifier.id.toLowerCase());
                if (gallery) {
                    mappedExtensions.push([installed, gallery]);
                }
            }
        }
        return mappedExtensions;
    }
    async updateMetadata(localExtension, gallery) {
        let isPreReleaseVersion = false;
        if (localExtension.manifest.version !== gallery.version) {
            this.telemetryService.publicLog2('galleryService:updateMetadata');
            const galleryWithLocalVersion = (await this.galleryService.getExtensions([{ ...localExtension.identifier, version: localExtension.manifest.version }], CancellationToken.None))[0];
            isPreReleaseVersion = !!galleryWithLocalVersion?.properties?.isPreReleaseVersion;
        }
        return this.server.extensionManagementService.updateMetadata(localExtension, { id: gallery.identifier.uuid, publisherDisplayName: gallery.publisherDisplayName, publisherId: gallery.publisherId, isPreReleaseVersion });
    }
    canInstall(galleryExtension) {
        return this.server.extensionManagementService.canInstall(galleryExtension);
    }
    onInstallExtension(event) {
        const { source } = event;
        if (source && !URI.isUri(source)) {
            const extension = this.installed.find(e => areSameExtensions(e.identifier, source.identifier))
                ?? this.instantiationService.createInstance(Extension, this.stateProvider, this.runtimeStateProvider, this.server, undefined, source, undefined);
            this.installing.push(extension);
            this._onChange.fire({ extension });
        }
    }
    async fetchInstalledExtensions(productVersion) {
        const extensionsControlManifest = await this.server.extensionManagementService.getExtensionsControlManifest();
        const all = await this.server.extensionManagementService.getInstalled(undefined, undefined, productVersion);
        if (this.isWorkspaceServer) {
            all.push(...(await this.workbenchExtensionManagementService.getInstalledWorkspaceExtensions(true)));
        }
        const installed = groupByExtension(all, r => r.identifier).reduce((result, extensions) => {
            const extension = extensions.length === 1 ? extensions[0]
                : extensions.find(e => e.type === 1 ) || extensions.find(e => e.type === 0 );
            result.push(extension);
            return result;
        }, []);
        const byId = index(this.installed, e => e.local ? e.local.identifier.id : e.identifier.id);
        this.installed = ( (installed.map(local => {
            const extension = byId[local.identifier.id] || this.instantiationService.createInstance(Extension, this.stateProvider, this.runtimeStateProvider, this.server, local, undefined, undefined);
            extension.local = local;
            extension.enablementState = this.extensionEnablementService.getEnablementState(local);
            Extensions_1.updateExtensionFromControlManifest(extension, extensionsControlManifest);
            return extension;
        })));
    }
    async reset() {
        this.installed = [];
        this.installing = [];
        this.uninstalling = [];
        await this.fetchInstalledExtensions();
        this._onReset.fire();
    }
    async onDidInstallExtensions(results) {
        for (const event of results) {
            const { local, source } = event;
            const gallery = source && !URI.isUri(source) ? source : undefined;
            const location = source && URI.isUri(source) ? source : undefined;
            const installingExtension = gallery ? this.installing.filter(e => areSameExtensions(e.identifier, gallery.identifier))[0] : null;
            this.installing = installingExtension ? this.installing.filter(e => e !== installingExtension) : this.installing;
            let extension = installingExtension ? installingExtension
                : (location || local) ? this.instantiationService.createInstance(Extension, this.stateProvider, this.runtimeStateProvider, this.server, local, undefined, undefined)
                    : undefined;
            if (extension) {
                if (local) {
                    const installed = this.installed.filter(e => areSameExtensions(e.identifier, extension.identifier))[0];
                    if (installed) {
                        extension = installed;
                    }
                    else {
                        this.installed.push(extension);
                    }
                    extension.local = local;
                    if (!extension.gallery) {
                        extension.gallery = gallery;
                    }
                    Extensions_1.updateExtensionFromControlManifest(extension, await this.server.extensionManagementService.getExtensionsControlManifest());
                    extension.enablementState = this.extensionEnablementService.getEnablementState(local);
                }
            }
            this._onChange.fire(!local || !extension ? undefined : { extension, operation: event.operation });
            if (extension && extension.local && !extension.gallery && extension.local.source !== 'resource') {
                await this.syncInstalledExtensionWithGallery(extension);
            }
        }
    }
    async onDidUpdateExtensionMetadata(local) {
        const extension = this.installed.find(e => areSameExtensions(e.identifier, local.identifier));
        if (extension?.local) {
            const hasChanged = extension.local.pinned !== local.pinned
                || extension.local.preRelease !== local.preRelease;
            extension.local = local;
            if (hasChanged) {
                this._onChange.fire({ extension });
            }
        }
    }
    async syncInstalledExtensionWithGallery(extension) {
        if (!this.galleryService.isEnabled()) {
            return;
        }
        this.telemetryService.publicLog2('galleryService:matchInstalledExtension');
        const [compatible] = await this.galleryService.getExtensions([{ ...extension.identifier, preRelease: extension.local?.preRelease }], { compatible: true, targetPlatform: await this.server.extensionManagementService.getTargetPlatform() }, CancellationToken.None);
        if (compatible) {
            extension.gallery = compatible;
            this._onChange.fire({ extension });
        }
    }
    onUninstallExtension(identifier) {
        const extension = this.installed.filter(e => areSameExtensions(e.identifier, identifier))[0];
        if (extension) {
            const uninstalling = this.uninstalling.filter(e => areSameExtensions(e.identifier, identifier))[0] || extension;
            this.uninstalling = [uninstalling, ...this.uninstalling.filter(e => !areSameExtensions(e.identifier, identifier))];
            this._onChange.fire(uninstalling ? { extension: uninstalling } : undefined);
        }
    }
    onDidUninstallExtension({ identifier, error }) {
        const uninstalled = this.uninstalling.find(e => areSameExtensions(e.identifier, identifier)) || this.installed.find(e => areSameExtensions(e.identifier, identifier));
        this.uninstalling = this.uninstalling.filter(e => !areSameExtensions(e.identifier, identifier));
        if (!error) {
            this.installed = this.installed.filter(e => !areSameExtensions(e.identifier, identifier));
        }
        if (uninstalled) {
            this._onChange.fire({ extension: uninstalled });
        }
    }
    onEnablementChanged(platformExtensions) {
        const extensions = this.local.filter(e => ( (platformExtensions.some(p => areSameExtensions(e.identifier, p.identifier)))));
        for (const extension of extensions) {
            if (extension.local) {
                const enablementState = this.extensionEnablementService.getEnablementState(extension.local);
                if (enablementState !== extension.enablementState) {
                    extension.enablementState = enablementState;
                    this._onChange.fire({ extension: extension });
                }
            }
        }
    }
    getExtensionState(extension) {
        if (extension.gallery && ( (this.installing.some(
            e => !!e.gallery && areSameExtensions(e.gallery.identifier, extension.gallery.identifier)
        )))) {
            return 0 ;
        }
        if (( (this.uninstalling.some(e => areSameExtensions(e.identifier, extension.identifier))))) {
            return 2 ;
        }
        const local = this.installed.filter(e => e === extension || (e.gallery && extension.gallery && areSameExtensions(e.gallery.identifier, extension.gallery.identifier)))[0];
        return local ? 1  : 3 ;
    }
};
Extensions = Extensions_1 = ( (__decorate([
    ( (__param(4, IExtensionGalleryService))),
    ( (__param(5, IWorkbenchExtensionEnablementService))),
    ( (__param(6, IWorkbenchExtensionManagementService))),
    ( (__param(7, ITelemetryService))),
    ( (__param(8, IInstantiationService)))
], Extensions)));
let ExtensionsWorkbenchService = class ExtensionsWorkbenchService extends Disposable {
    static { ExtensionsWorkbenchService_1 = this; }
    static { this.UpdatesCheckInterval = 1000 * 60 * 60 * 12; }
    get onChange() { return this._onChange.event; }
    get onReset() { return this._onReset.event; }
    constructor(instantiationService, editorService, extensionManagementService, galleryService, configurationService, telemetryService, notificationService, urlService, extensionEnablementService, hostService, progressService, extensionManagementServerService, languageService, extensionsSyncManagementService, userDataAutoSyncService, productService, contextKeyService, extensionManifestPropertiesService, logService, extensionService, localeService, lifecycleService, fileService, userDataProfileService, storageService, dialogService, userDataSyncEnablementService, updateService, uriIdentityService, workspaceContextService) {
        super();
        this.instantiationService = instantiationService;
        this.editorService = editorService;
        this.extensionManagementService = extensionManagementService;
        this.galleryService = galleryService;
        this.configurationService = configurationService;
        this.telemetryService = telemetryService;
        this.notificationService = notificationService;
        this.extensionEnablementService = extensionEnablementService;
        this.hostService = hostService;
        this.progressService = progressService;
        this.extensionManagementServerService = extensionManagementServerService;
        this.languageService = languageService;
        this.extensionsSyncManagementService = extensionsSyncManagementService;
        this.userDataAutoSyncService = userDataAutoSyncService;
        this.productService = productService;
        this.extensionManifestPropertiesService = extensionManifestPropertiesService;
        this.logService = logService;
        this.extensionService = extensionService;
        this.localeService = localeService;
        this.lifecycleService = lifecycleService;
        this.fileService = fileService;
        this.userDataProfileService = userDataProfileService;
        this.storageService = storageService;
        this.dialogService = dialogService;
        this.userDataSyncEnablementService = userDataSyncEnablementService;
        this.updateService = updateService;
        this.uriIdentityService = uriIdentityService;
        this.workspaceContextService = workspaceContextService;
        this.localExtensions = null;
        this.remoteExtensions = null;
        this.webExtensions = null;
        this.extensionsServers = [];
        this._onChange = ( (new Emitter()));
        this._onReset = ( (new Emitter()));
        this.preferPreReleases = this.productService.quality !== 'stable';
        this.installing = [];
        this.tasksInProgress = [];
        const preferPreReleasesValue = configurationService.getValue('_extensions.preferPreReleases');
        if (!isUndefined(preferPreReleasesValue)) {
            this.preferPreReleases = !!preferPreReleasesValue;
        }
        this.hasOutdatedExtensionsContextKey = HasOutdatedExtensionsContext.bindTo(contextKeyService);
        if (extensionManagementServerService.localExtensionManagementServer) {
            this.localExtensions = this._register(instantiationService.createInstance(Extensions, extensionManagementServerService.localExtensionManagementServer, ext => this.getExtensionState(ext), ext => this.getRuntimeState(ext), !extensionManagementServerService.remoteExtensionManagementServer));
            this._register(this.localExtensions.onChange(e => this.onDidChangeExtensions(e?.extension)));
            this._register(this.localExtensions.onReset(e => this.reset()));
            this.extensionsServers.push(this.localExtensions);
        }
        if (extensionManagementServerService.remoteExtensionManagementServer) {
            this.remoteExtensions = this._register(instantiationService.createInstance(Extensions, extensionManagementServerService.remoteExtensionManagementServer, ext => this.getExtensionState(ext), ext => this.getRuntimeState(ext), true));
            this._register(this.remoteExtensions.onChange(e => this.onDidChangeExtensions(e?.extension)));
            this._register(this.remoteExtensions.onReset(e => this.reset()));
            this.extensionsServers.push(this.remoteExtensions);
        }
        if (extensionManagementServerService.webExtensionManagementServer) {
            this.webExtensions = this._register(instantiationService.createInstance(Extensions, extensionManagementServerService.webExtensionManagementServer, ext => this.getExtensionState(ext), ext => this.getRuntimeState(ext), !(extensionManagementServerService.remoteExtensionManagementServer || extensionManagementServerService.localExtensionManagementServer)));
            this._register(this.webExtensions.onChange(e => this.onDidChangeExtensions(e?.extension)));
            this._register(this.webExtensions.onReset(e => this.reset()));
            this.extensionsServers.push(this.webExtensions);
        }
        this.updatesCheckDelayer = ( (new ThrottledDelayer(ExtensionsWorkbenchService_1.UpdatesCheckInterval)));
        this.autoUpdateDelayer = ( (new ThrottledDelayer(1000)));
        this._register(toDisposable(() => {
            this.updatesCheckDelayer.cancel();
            this.autoUpdateDelayer.cancel();
        }));
        urlService.registerHandler(this);
        this.whenInitialized = this.initialize();
    }
    async initialize() {
        await Promise.all([this.queryLocal(), this.extensionService.whenInstalledExtensionsRegistered()]);
        if (this._store.isDisposed) {
            return;
        }
        this.onDidChangeRunningExtensions(this.extensionService.extensions, []);
        this._register(this.extensionService.onDidChangeExtensions(({ added, removed }) => this.onDidChangeRunningExtensions(added, removed)));
        await this.lifecycleService.when(4 );
        if (this._store.isDisposed) {
            return;
        }
        this.initializeAutoUpdate();
        this.reportInstalledExtensionsTelemetry();
        this._register(Event.debounce(this.onChange, () => undefined, 100)(() => this.reportProgressFromOtherSources()));
        this._register(this.storageService.onDidChangeValue(-1 , EXTENSIONS_AUTO_UPDATE_KEY, this._store)(e => this.onDidSelectedExtensionToAutoUpdateValueChange(false)));
    }
    initializeAutoUpdate() {
        this._register(this.configurationService.onDidChangeConfiguration(e => {
            if (e.affectsConfiguration(AutoUpdateConfigurationKey)) {
                this.onDidAutoUpdateConfigurationChange();
            }
            if (e.affectsConfiguration(AutoCheckUpdatesConfigurationKey)) {
                if (this.isAutoCheckUpdatesEnabled()) {
                    this.checkForUpdates();
                }
            }
        }));
        this._register(this.extensionEnablementService.onEnablementChanged(platformExtensions => {
            if (this.getAutoUpdateValue() === 'onlyEnabledExtensions' && ( (platformExtensions.some(e => this.extensionEnablementService.isEnabled(e))))) {
                this.checkForUpdates();
            }
        }));
        this._register(Event.debounce(this.onChange, () => undefined, 100)(() => this.hasOutdatedExtensionsContextKey.set(this.outdated.length > 0)));
        this._register(this.updateService.onStateChange(e => {
            if (!this.isAutoUpdateEnabled()) {
                return;
            }
            if ((e.type === "checking for updates"  && e.explicit) || e.type === "available for download"  || e.type === "downloaded" ) {
                this.eventuallyCheckForUpdates(true);
            }
        }));
        this.hasOutdatedExtensionsContextKey.set(this.outdated.length > 0);
        this.eventuallyCheckForUpdates(true);
        if (isWeb) {
            this.syncPinnedBuiltinExtensions();
            if (!this.isAutoUpdateEnabled()) {
                this.autoUpdateBuiltinExtensions();
            }
        }
    }
    reportInstalledExtensionsTelemetry() {
        const extensionIds = ( (this.installed.filter(extension => !extension.isBuiltin &&
            ((extension.enablementState === 9  || extension.enablementState === 8) ))
            .map(extension => ExtensionIdentifier.toKey(extension.identifier.id))));
        this.telemetryService.publicLog2('installedExtensions', { extensionIds: ( (new TelemetryTrustedValue(extensionIds.join(';')))), count: extensionIds.length });
    }
    async onDidChangeRunningExtensions(added, removed) {
        const changedExtensions = [];
        const extensionsToFetch = [];
        for (const desc of added) {
            const extension = this.installed.find(e => areSameExtensions({ id: desc.identifier.value, uuid: desc.uuid }, e.identifier));
            if (extension) {
                changedExtensions.push(extension);
            }
            else {
                extensionsToFetch.push(desc);
            }
        }
        const workspaceExtensions = [];
        for (const desc of removed) {
            if (this.workspaceContextService.isInsideWorkspace(desc.extensionLocation)) {
                workspaceExtensions.push(desc);
            }
            else {
                extensionsToFetch.push(desc);
            }
        }
        if (extensionsToFetch.length) {
            const extensions = await this.getExtensions(( (extensionsToFetch.map(e => ({ id: e.identifier.value, uuid: e.uuid })))), CancellationToken.None);
            changedExtensions.push(...extensions);
        }
        if (workspaceExtensions.length) {
            const extensions = await this.getResourceExtensions(( (workspaceExtensions.map(e => e.extensionLocation))), true);
            changedExtensions.push(...extensions);
        }
        for (const changedExtension of changedExtensions) {
            this._onChange.fire(changedExtension);
        }
    }
    reset() {
        for (const task of this.tasksInProgress) {
            task.cancel();
        }
        this.tasksInProgress = [];
        this.installing = [];
        this.onDidChangeExtensions();
        this._onReset.fire();
    }
    onDidChangeExtensions(extension) {
        this._installed = undefined;
        this._local = undefined;
        this._onChange.fire(extension);
    }
    get local() {
        if (!this._local) {
            if (this.extensionsServers.length === 1) {
                this._local = this.installed;
            }
            else {
                this._local = [];
                const byId = groupByExtension(this.installed, r => r.identifier);
                for (const extensions of byId) {
                    this._local.push(this.getPrimaryExtension(extensions));
                }
            }
        }
        return this._local;
    }
    get installed() {
        if (!this._installed) {
            this._installed = [];
            for (const extensions of this.extensionsServers) {
                for (const extension of extensions.local) {
                    this._installed.push(extension);
                }
            }
        }
        return this._installed;
    }
    get outdated() {
        return this.installed.filter(e => e.outdated && e.local && e.state === 1 );
    }
    async queryLocal(server) {
        if (server) {
            if (this.localExtensions && this.extensionManagementServerService.localExtensionManagementServer === server) {
                return this.localExtensions.queryInstalled(this.getProductVersion());
            }
            if (this.remoteExtensions && this.extensionManagementServerService.remoteExtensionManagementServer === server) {
                return this.remoteExtensions.queryInstalled(this.getProductVersion());
            }
            if (this.webExtensions && this.extensionManagementServerService.webExtensionManagementServer === server) {
                return this.webExtensions.queryInstalled(this.getProductVersion());
            }
        }
        if (this.localExtensions) {
            try {
                await this.localExtensions.queryInstalled(this.getProductVersion());
            }
            catch (error) {
                this.logService.error(error);
            }
        }
        if (this.remoteExtensions) {
            try {
                await this.remoteExtensions.queryInstalled(this.getProductVersion());
            }
            catch (error) {
                this.logService.error(error);
            }
        }
        if (this.webExtensions) {
            try {
                await this.webExtensions.queryInstalled(this.getProductVersion());
            }
            catch (error) {
                this.logService.error(error);
            }
        }
        return this.local;
    }
    async queryGallery(arg1, arg2) {
        if (!this.galleryService.isEnabled()) {
            return singlePagePager([]);
        }
        const options = CancellationToken.isCancellationToken(arg1) ? {} : arg1;
        const token = CancellationToken.isCancellationToken(arg1) ? arg1 : arg2;
        options.text = options.text ? this.resolveQueryText(options.text) : options.text;
        options.includePreRelease = isUndefined(options.includePreRelease) ? this.preferPreReleases : options.includePreRelease;
        const extensionsControlManifest = await this.extensionManagementService.getExtensionsControlManifest();
        const pager = await this.galleryService.query(options, token);
        this.syncInstalledExtensionsWithGallery(pager.firstPage);
        return {
            firstPage: ( (pager.firstPage.map(gallery => this.fromGallery(gallery, extensionsControlManifest)))),
            total: pager.total,
            pageSize: pager.pageSize,
            getPage: async (pageIndex, token) => {
                const page = await pager.getPage(pageIndex, token);
                this.syncInstalledExtensionsWithGallery(page);
                return (
                     (page.map(gallery => this.fromGallery(gallery, extensionsControlManifest)))
                );
            }
        };
    }
    async getExtensions(extensionInfos, arg1, arg2) {
        if (!this.galleryService.isEnabled()) {
            return [];
        }
        extensionInfos.forEach(e => e.preRelease = e.preRelease ?? this.preferPreReleases);
        const extensionsControlManifest = await this.extensionManagementService.getExtensionsControlManifest();
        const galleryExtensions = await this.galleryService.getExtensions(extensionInfos, arg1, arg2);
        this.syncInstalledExtensionsWithGallery(galleryExtensions);
        return (
             (galleryExtensions.map(gallery => this.fromGallery(gallery, extensionsControlManifest)))
        );
    }
    async getResourceExtensions(locations, isWorkspaceScoped) {
        const resourceExtensions = await this.extensionManagementService.getExtensions(locations);
        return (
             (resourceExtensions.map(
                resourceExtension => this.getInstalledExtensionMatchingLocation(resourceExtension.location)
                    ?? this.instantiationService.createInstance(Extension, ext => this.getExtensionState(ext), ext => this.getRuntimeState(ext), undefined, undefined, undefined, { resourceExtension, isWorkspaceScoped })
            ))
        );
    }
    resolveQueryText(text) {
        text = text.replace(/@web/g, `tag:"${WEB_EXTENSION_TAG}"`);
        const extensionRegex = /\bext:([^\s]+)\b/g;
        if (extensionRegex.test(text)) {
            text = text.replace(extensionRegex, (m, ext) => {
                const lookup = this.productService.extensionKeywords || {};
                const keywords = lookup[ext] || [];
                const languageId = this.languageService.guessLanguageIdByFilepathOrFirstLine(URI.file(`.${ext}`));
                const languageName = languageId && this.languageService.getLanguageName(languageId);
                const languageTag = languageName ? ` tag:"${languageName}"` : '';
                return `tag:"__ext_${ext}" tag:"__ext_.${ext}" ${( (keywords.map(tag => `tag:"${tag}"`))).join(' ')}${languageTag} tag:"${ext}"`;
            });
        }
        return text.substr(0, 350);
    }
    fromGallery(gallery, extensionsControlManifest) {
        let extension = this.getInstalledExtensionMatchingGallery(gallery);
        if (!extension) {
            extension = this.instantiationService.createInstance(Extension, ext => this.getExtensionState(ext), ext => this.getRuntimeState(ext), undefined, undefined, gallery, undefined);
            Extensions.updateExtensionFromControlManifest(extension, extensionsControlManifest);
        }
        return extension;
    }
    getInstalledExtensionMatchingGallery(gallery) {
        for (const installed of this.local) {
            if (installed.identifier.uuid) {
                if (installed.identifier.uuid === gallery.identifier.uuid) {
                    return installed;
                }
            }
            else if (installed.local?.source !== 'resource') {
                if (areSameExtensions(installed.identifier, gallery.identifier)) {
                    return installed;
                }
            }
        }
        return null;
    }
    getInstalledExtensionMatchingLocation(location) {
        return this.local.find(e => e.local && this.uriIdentityService.extUri.isEqualOrParent(location, e.local?.location)) ?? null;
    }
    async open(extension, options) {
        if (typeof extension === 'string') {
            const id = extension;
            extension = this.installed.find(e => areSameExtensions(e.identifier, { id })) ?? (await this.getExtensions([{ id: extension }], CancellationToken.None))[0];
        }
        if (!extension) {
            throw ( (new Error(`Extension not found. ${extension}`)));
        }
        await this.editorService.openEditor(this.instantiationService.createInstance(ExtensionsInput, extension), options, options?.sideByside ? SIDE_GROUP : ACTIVE_GROUP);
    }
    getExtensionStatus(extension) {
        const extensionsStatus = this.extensionService.getExtensionsStatus();
        for (const id of ( (Object.keys(extensionsStatus)))) {
            if (areSameExtensions({ id }, extension.identifier)) {
                return extensionsStatus[id];
            }
        }
        return undefined;
    }
    async updateRunningExtensions() {
        const toAdd = [];
        const toRemove = [];
        const extensionsToCheck = [...this.local];
        for (const extension of extensionsToCheck) {
            const runtimeState = extension.runtimeState;
            if (!runtimeState || runtimeState.action !== "restartExtensions" ) {
                continue;
            }
            if (extension.state === 3 ) {
                toRemove.push(extension.identifier.id);
                continue;
            }
            if (!extension.local) {
                continue;
            }
            const isEnabled = this.extensionEnablementService.isEnabled(extension.local);
            if (isEnabled) {
                const runningExtension = this.extensionService.extensions.find(e => areSameExtensions({ id: e.identifier.value, uuid: e.uuid }, extension.identifier));
                if (runningExtension) {
                    toRemove.push(runningExtension.identifier.value);
                }
                toAdd.push(extension.local);
            }
            else {
                toRemove.push(extension.identifier.id);
            }
        }
        for (const extension of this.extensionService.extensions) {
            if (extension.isUnderDevelopment) {
                continue;
            }
            if (( (extensionsToCheck.some(
                e => areSameExtensions({ id: extension.identifier.value, uuid: extension.uuid }, e.identifier)
            )))) {
                continue;
            }
            toRemove.push(extension.identifier.value);
        }
        if (toAdd.length || toRemove.length) {
            if (await this.extensionService.stopExtensionHosts(( localizeWithPath(_moduleId, 1, "Enable or Disable extensions")))) {
                await this.extensionService.startExtensionHosts({ toAdd, toRemove });
            }
        }
    }
    getRuntimeState(extension) {
        const isUninstalled = extension.state === 3 ;
        const runningExtension = this.extensionService.extensions.find(e => areSameExtensions({ id: e.identifier.value, uuid: e.uuid }, extension.identifier));
        const reloadAction = this.extensionManagementServerService.remoteExtensionManagementServer ? "reloadWindow"  : "restartExtensions" ;
        const reloadActionLabel = reloadAction === "reloadWindow"  ? ( localizeWithPath(_moduleId, 2, "reload window")) : ( localizeWithPath(_moduleId, 3, "restart extensions"));
        if (isUninstalled) {
            const canRemoveRunningExtension = runningExtension && this.extensionService.canRemoveExtension(runningExtension);
            const isSameExtensionRunning = runningExtension && (!extension.server || extension.server === this.extensionManagementServerService.getExtensionManagementServer(toExtension(runningExtension)));
            if (!canRemoveRunningExtension && isSameExtensionRunning && !runningExtension.isUnderDevelopment) {
                return { action: reloadAction, reason: ( localizeWithPath(
                    _moduleId,
                    4,
                    "Please {0} to complete the uninstallation of this extension.",
                    reloadActionLabel
                )) };
            }
            return undefined;
        }
        if (extension.local) {
            const isSameExtensionRunning = runningExtension && extension.server === this.extensionManagementServerService.getExtensionManagementServer(toExtension(runningExtension));
            const isEnabled = this.extensionEnablementService.isEnabled(extension.local);
            if (runningExtension) {
                if (isEnabled) {
                    if (this.extensionService.canAddExtension(toExtensionDescription(extension.local))) {
                        return undefined;
                    }
                    const runningExtensionServer = this.extensionManagementServerService.getExtensionManagementServer(toExtension(runningExtension));
                    if (isSameExtensionRunning) {
                        if (!runningExtension.isUnderDevelopment && (extension.version !== runningExtension.version || extension.local.targetPlatform !== runningExtension.targetPlatform)) {
                            const productCurrentVersion = this.getProductCurrentVersion();
                            const productUpdateVersion = this.getProductUpdateVersion();
                            if (productUpdateVersion
                                && !isEngineValid(extension.local.manifest.engines.vscode, productCurrentVersion.version, productCurrentVersion.date)
                                && isEngineValid(extension.local.manifest.engines.vscode, productUpdateVersion.version, productUpdateVersion.date)) {
                                const state = this.updateService.state;
                                if (state.type === "available for download" ) {
                                    return { action: "downloadUpdate" , reason: ( localizeWithPath(
                                        _moduleId,
                                        5,
                                        "Please update {0} to enable the updated extension.",
                                        this.productService.nameLong
                                    )) };
                                }
                                if (state.type === "downloaded" ) {
                                    return { action: "applyUpdate" , reason: ( localizeWithPath(
                                        _moduleId,
                                        6,
                                        "Please update {0} to enable the updated extension.",
                                        this.productService.nameLong
                                    )) };
                                }
                                if (state.type === "ready" ) {
                                    return { action: "quitAndInstall" , reason: ( localizeWithPath(
                                        _moduleId,
                                        7,
                                        "Please restart {0} to enable the updated extension.",
                                        this.productService.nameLong
                                    )) };
                                }
                                return undefined;
                            }
                            return { action: reloadAction, reason: ( localizeWithPath(
                                _moduleId,
                                8,
                                "Please {0} to enable the updated extension.",
                                reloadActionLabel
                            )) };
                        }
                        if (this.extensionsServers.length > 1) {
                            const extensionInOtherServer = this.installed.filter(e => areSameExtensions(e.identifier, extension.identifier) && e.server !== extension.server)[0];
                            if (extensionInOtherServer) {
                                if (runningExtensionServer === this.extensionManagementServerService.remoteExtensionManagementServer && this.extensionManifestPropertiesService.prefersExecuteOnUI(extension.local.manifest) && extensionInOtherServer.server === this.extensionManagementServerService.localExtensionManagementServer) {
                                    return { action: reloadAction, reason: ( localizeWithPath(
                                        _moduleId,
                                        9,
                                        "Please {0} to enable this extension locally.",
                                        reloadActionLabel
                                    )) };
                                }
                                if (runningExtensionServer === this.extensionManagementServerService.localExtensionManagementServer && this.extensionManifestPropertiesService.prefersExecuteOnWorkspace(extension.local.manifest) && extensionInOtherServer.server === this.extensionManagementServerService.remoteExtensionManagementServer) {
                                    return { action: reloadAction, reason: ( localizeWithPath(
                                        _moduleId,
                                        10,
                                        "Please {0} to enable this extension in {1}.",
                                        reloadActionLabel,
                                        this.extensionManagementServerService.remoteExtensionManagementServer?.label
                                    )) };
                                }
                            }
                        }
                    }
                    else {
                        if (extension.server === this.extensionManagementServerService.localExtensionManagementServer && runningExtensionServer === this.extensionManagementServerService.remoteExtensionManagementServer) {
                            if (this.extensionManifestPropertiesService.prefersExecuteOnUI(extension.local.manifest)) {
                                return { action: reloadAction, reason: ( localizeWithPath(_moduleId, 11, "Please {0} to enable this extension.", reloadActionLabel)) };
                            }
                        }
                        if (extension.server === this.extensionManagementServerService.remoteExtensionManagementServer && runningExtensionServer === this.extensionManagementServerService.localExtensionManagementServer) {
                            if (this.extensionManifestPropertiesService.prefersExecuteOnWorkspace(extension.local.manifest)) {
                                return { action: reloadAction, reason: ( localizeWithPath(_moduleId, 11, "Please {0} to enable this extension.", reloadActionLabel)) };
                            }
                        }
                    }
                    return undefined;
                }
                else {
                    if (isSameExtensionRunning) {
                        return { action: reloadAction, reason: ( localizeWithPath(_moduleId, 12, "Please {0} to disable this extension.", reloadActionLabel)) };
                    }
                }
                return undefined;
            }
            else {
                if (isEnabled && !this.extensionService.canAddExtension(toExtensionDescription(extension.local))) {
                    return { action: reloadAction, reason: ( localizeWithPath(_moduleId, 11, "Please {0} to enable this extension.", reloadActionLabel)) };
                }
                const otherServer = extension.server ? extension.server === this.extensionManagementServerService.localExtensionManagementServer ? this.extensionManagementServerService.remoteExtensionManagementServer : this.extensionManagementServerService.localExtensionManagementServer : null;
                if (otherServer && extension.enablementState === 1 ) {
                    const extensionInOtherServer = this.local.filter(e => areSameExtensions(e.identifier, extension.identifier) && e.server === otherServer)[0];
                    if (extensionInOtherServer && extensionInOtherServer.local && this.extensionEnablementService.isEnabled(extensionInOtherServer.local)) {
                        return { action: reloadAction, reason: ( localizeWithPath(_moduleId, 11, "Please {0} to enable this extension.", reloadActionLabel)) };
                    }
                }
            }
        }
        return undefined;
    }
    getPrimaryExtension(extensions) {
        if (extensions.length === 1) {
            return extensions[0];
        }
        const enabledExtensions = extensions.filter(e => e.local && this.extensionEnablementService.isEnabled(e.local));
        if (enabledExtensions.length === 1) {
            return enabledExtensions[0];
        }
        const extensionsToChoose = enabledExtensions.length ? enabledExtensions : extensions;
        const manifest = extensionsToChoose.find(e => e.local && e.local.manifest)?.local?.manifest;
        if (!manifest) {
            return extensionsToChoose[0];
        }
        const extensionKinds = this.extensionManifestPropertiesService.getExtensionKind(manifest);
        let extension = extensionsToChoose.find(extension => {
            for (const extensionKind of extensionKinds) {
                switch (extensionKind) {
                    case 'ui':
                        if (extension.server === this.extensionManagementServerService.localExtensionManagementServer) {
                            return true;
                        }
                        return false;
                    case 'workspace':
                        if (extension.server === this.extensionManagementServerService.remoteExtensionManagementServer) {
                            return true;
                        }
                        return false;
                    case 'web':
                        if (extension.server === this.extensionManagementServerService.webExtensionManagementServer) {
                            return true;
                        }
                        return false;
                }
            }
            return false;
        });
        if (!extension && this.extensionManagementServerService.localExtensionManagementServer) {
            extension = extensionsToChoose.find(extension => {
                for (const extensionKind of extensionKinds) {
                    switch (extensionKind) {
                        case 'workspace':
                            if (extension.server === this.extensionManagementServerService.localExtensionManagementServer) {
                                return true;
                            }
                            return false;
                        case 'web':
                            if (extension.server === this.extensionManagementServerService.localExtensionManagementServer) {
                                return true;
                            }
                            return false;
                    }
                }
                return false;
            });
        }
        if (!extension && this.extensionManagementServerService.webExtensionManagementServer) {
            extension = extensionsToChoose.find(extension => {
                for (const extensionKind of extensionKinds) {
                    switch (extensionKind) {
                        case 'web':
                            if (extension.server === this.extensionManagementServerService.webExtensionManagementServer) {
                                return true;
                            }
                            return false;
                    }
                }
                return false;
            });
        }
        if (!extension && this.extensionManagementServerService.remoteExtensionManagementServer) {
            extension = extensionsToChoose.find(extension => {
                for (const extensionKind of extensionKinds) {
                    switch (extensionKind) {
                        case 'web':
                            if (extension.server === this.extensionManagementServerService.remoteExtensionManagementServer) {
                                return true;
                            }
                            return false;
                    }
                }
                return false;
            });
        }
        return extension || extensions[0];
    }
    getExtensionState(extension) {
        if (( (this.installing.some(
            i => areSameExtensions(i.identifier, extension.identifier) && (!extension.server || i.server === extension.server)
        )))) {
            return 0 ;
        }
        if (this.remoteExtensions) {
            const state = this.remoteExtensions.getExtensionState(extension);
            if (state !== 3 ) {
                return state;
            }
        }
        if (this.webExtensions) {
            const state = this.webExtensions.getExtensionState(extension);
            if (state !== 3 ) {
                return state;
            }
        }
        if (this.localExtensions) {
            return this.localExtensions.getExtensionState(extension);
        }
        return 3 ;
    }
    async onDidAutoUpdateConfigurationChange() {
        await this.updateExtensionsPinnedState();
        if (this.isAutoUpdateEnabled()) {
            this.checkForUpdates();
        }
        else {
            this.setSelectedExtensionsToAutoUpdate([]);
        }
    }
    async checkForUpdates(onlyBuiltin) {
        if (!this.galleryService.isEnabled()) {
            return;
        }
        const extensions = [];
        if (this.localExtensions) {
            extensions.push(this.localExtensions);
        }
        if (this.remoteExtensions) {
            extensions.push(this.remoteExtensions);
        }
        if (this.webExtensions) {
            extensions.push(this.webExtensions);
        }
        if (!extensions.length) {
            return;
        }
        const infos = [];
        for (const installed of this.local) {
            if (onlyBuiltin && !installed.isBuiltin) {
                continue;
            }
            if (installed.isBuiltin && !installed.local?.pinned && (installed.type === 0  || !installed.local?.identifier.uuid)) {
                continue;
            }
            if (installed.local?.source === 'resource') {
                continue;
            }
            infos.push({ ...installed.identifier, preRelease: !!installed.local?.preRelease });
        }
        if (infos.length) {
            const targetPlatform = await extensions[0].server.extensionManagementService.getTargetPlatform();
            this.telemetryService.publicLog2('galleryService:checkingForUpdates', {
                count: infos.length,
            });
            const galleryExtensions = await this.galleryService.getExtensions(infos, { targetPlatform, compatible: true, productVersion: this.getProductVersion() }, CancellationToken.None);
            if (galleryExtensions.length) {
                await this.syncInstalledExtensionsWithGallery(galleryExtensions);
            }
        }
    }
    async updateAll() {
        const toUpdate = [];
        this.outdated.forEach((extension) => {
            if (extension.gallery) {
                toUpdate.push({
                    extension: extension.gallery,
                    options: {
                        operation: 3 ,
                        installPreReleaseVersion: extension.local?.isPreReleaseVersion,
                        profileLocation: this.userDataProfileService.currentProfile.extensionsResource,
                    }
                });
            }
        });
        return this.extensionManagementService.installGalleryExtensions(toUpdate);
    }
    async syncInstalledExtensionsWithGallery(gallery) {
        const extensions = [];
        if (this.localExtensions) {
            extensions.push(this.localExtensions);
        }
        if (this.remoteExtensions) {
            extensions.push(this.remoteExtensions);
        }
        if (this.webExtensions) {
            extensions.push(this.webExtensions);
        }
        if (!extensions.length) {
            return;
        }
        await Promise.allSettled(( (extensions.map(
            extensions => extensions.syncInstalledExtensionsWithGallery(gallery, this.getProductVersion())
        ))));
        if (this.isAutoUpdateEnabled()) {
            this.eventuallyAutoUpdateExtensions();
        }
    }
    getAutoUpdateValue() {
        const autoUpdate = this.configurationService.getValue(AutoUpdateConfigurationKey);
        return isBoolean(autoUpdate) || autoUpdate === 'onlyEnabledExtensions' || autoUpdate === 'onlySelectedExtensions' ? autoUpdate : true;
    }
    isAutoUpdateEnabled() {
        return this.getAutoUpdateValue() !== false;
    }
    isAutoCheckUpdatesEnabled() {
        return this.configurationService.getValue(AutoCheckUpdatesConfigurationKey);
    }
    eventuallyCheckForUpdates(immediate = false) {
        this.updatesCheckDelayer.cancel();
        this.updatesCheckDelayer.trigger(async () => {
            if (this.isAutoUpdateEnabled() || this.isAutoCheckUpdatesEnabled()) {
                await this.checkForUpdates();
            }
            this.eventuallyCheckForUpdates();
        }, immediate ? 0 : this.getUpdatesCheckInterval()).then(undefined, err => null);
    }
    getUpdatesCheckInterval() {
        if (this.productService.quality === 'insider' && this.getProductUpdateVersion()) {
            return 1000 * 60 * 60 * 1;
        }
        return ExtensionsWorkbenchService_1.UpdatesCheckInterval;
    }
    eventuallyAutoUpdateExtensions() {
        this.autoUpdateDelayer.trigger(() => this.autoUpdateExtensions())
            .then(undefined, err => null);
    }
    async autoUpdateBuiltinExtensions() {
        await this.checkForUpdates(true);
        const toUpdate = this.outdated.filter(e => e.isBuiltin);
        await Promises.settled(( (toUpdate.map(
            e => this.install(e, e.local?.preRelease ? { installPreReleaseVersion: true } : undefined)
        ))));
    }
    async syncPinnedBuiltinExtensions() {
        const infos = [];
        for (const installed of this.local) {
            if (installed.isBuiltin && installed.local?.pinned && installed.local?.identifier.uuid) {
                infos.push({ ...installed.identifier, version: installed.version });
            }
        }
        if (infos.length) {
            const galleryExtensions = await this.galleryService.getExtensions(infos, CancellationToken.None);
            if (galleryExtensions.length) {
                await this.syncInstalledExtensionsWithGallery(galleryExtensions);
            }
        }
    }
    async autoUpdateExtensions() {
        if (!this.isAutoUpdateEnabled()) {
            return;
        }
        const toUpdate = this.outdated.filter(e => !e.local?.pinned && this.shouldAutoUpdateExtension(e));
        if (!toUpdate.length) {
            return;
        }
        const productVersion = this.getProductVersion();
        await Promises.settled(( (toUpdate.map(
            e => this.install(e, e.local?.preRelease ? { installPreReleaseVersion: true, productVersion } : { productVersion })
        ))));
    }
    getProductVersion() {
        return this.getProductUpdateVersion() ?? this.getProductCurrentVersion();
    }
    getProductCurrentVersion() {
        return { version: this.productService.version, date: this.productService.date };
    }
    getProductUpdateVersion() {
        switch (this.updateService.state.type) {
            case "available for download" :
            case "downloaded" :
            case "updating" :
            case "ready" : {
                const version = this.updateService.state.update.productVersion;
                if (version && semverExports.valid(version)) {
                    return { version, date: this.updateService.state.update.timestamp ? ( (new Date(this.updateService.state.update.timestamp))).toISOString() : undefined };
                }
            }
        }
        return undefined;
    }
    async updateExtensionsPinnedState() {
        await Promise.all(( (this.installed.map(async (e) => {
            if (e.isBuiltin) {
                return;
            }
            const shouldBePinned = !this.shouldAutoUpdateExtension(e);
            if (e.local && e.local.pinned !== shouldBePinned) {
                await this.extensionManagementService.updateMetadata(e.local, { pinned: shouldBePinned });
            }
        }))));
    }
    shouldAutoUpdateExtension(extension) {
        const autoUpdate = this.getAutoUpdateValue();
        if (isBoolean(autoUpdate)) {
            return autoUpdate;
        }
        if (autoUpdate === 'onlyEnabledExtensions') {
            return this.extensionEnablementService.isEnabledEnablementState(extension.enablementState);
        }
        const extensionsToAutoUpdate = this.getSelectedExtensionsToAutoUpdate();
        const extensionId = extension.identifier.id.toLowerCase();
        return extensionsToAutoUpdate.includes(extensionId) ||
            (!extensionsToAutoUpdate.includes(`-${extensionId}`) && this.isAutoUpdateEnabledForPublisher(extension.publisher));
    }
    isAutoUpdateEnabledFor(extensionOrPublisher) {
        if (isString(extensionOrPublisher)) {
            if (EXTENSION_IDENTIFIER_REGEX.test(extensionOrPublisher)) {
                throw ( (new Error('Expected publisher string, found extension identifier')));
            }
            const autoUpdate = this.getAutoUpdateValue();
            if (isBoolean(autoUpdate)) {
                return autoUpdate;
            }
            if (autoUpdate === 'onlyEnabledExtensions') {
                return false;
            }
            return this.isAutoUpdateEnabledForPublisher(extensionOrPublisher);
        }
        return !extensionOrPublisher.local?.pinned && this.shouldAutoUpdateExtension(extensionOrPublisher);
    }
    isAutoUpdateEnabledForPublisher(publisher) {
        const publishersToAutoUpdate = this.getPublishersToAutoUpdate();
        return publishersToAutoUpdate.includes(publisher.toLowerCase());
    }
    async updateAutoUpdateEnablementFor(extensionOrPublisher, enable) {
        const autoUpdateValue = this.getAutoUpdateValue();
        if (autoUpdateValue === true || autoUpdateValue === 'onlyEnabledExtensions') {
            if (isString(extensionOrPublisher)) {
                throw ( (new Error('Expected extension, found publisher string')));
            }
            if (!extensionOrPublisher.local) {
                throw ( (new Error('Only installed extensions can be pinned')));
            }
            await this.extensionManagementService.updateMetadata(extensionOrPublisher.local, { pinned: !enable });
            if (enable) {
                this.eventuallyAutoUpdateExtensions();
            }
            return;
        }
        if (autoUpdateValue === false && enable) {
            await this.configurationService.updateValue(AutoUpdateConfigurationKey, 'onlySelectedExtensions');
        }
        let update = false;
        const autoUpdateExtensions = this.getSelectedExtensionsToAutoUpdate();
        if (isString(extensionOrPublisher)) {
            if (EXTENSION_IDENTIFIER_REGEX.test(extensionOrPublisher)) {
                throw ( (new Error('Expected publisher string, found extension identifier')));
            }
            extensionOrPublisher = extensionOrPublisher.toLowerCase();
            if (this.isAutoUpdateEnabledFor(extensionOrPublisher) !== enable) {
                update = true;
                if (enable) {
                    autoUpdateExtensions.push(extensionOrPublisher);
                }
                else {
                    if (autoUpdateExtensions.includes(extensionOrPublisher)) {
                        autoUpdateExtensions.splice(autoUpdateExtensions.indexOf(extensionOrPublisher), 1);
                    }
                }
            }
        }
        else {
            const extensionId = extensionOrPublisher.identifier.id.toLowerCase();
            const enableAutoUpdatesForPublisher = this.isAutoUpdateEnabledFor(extensionOrPublisher.publisher.toLowerCase());
            const enableAutoUpdatesForExtension = autoUpdateExtensions.includes(extensionId);
            const disableAutoUpdatesForExtension = autoUpdateExtensions.includes(`-${extensionId}`);
            if (enable) {
                if (disableAutoUpdatesForExtension) {
                    autoUpdateExtensions.splice(autoUpdateExtensions.indexOf(`-${extensionId}`), 1);
                    update = true;
                }
                if (enableAutoUpdatesForPublisher) {
                    if (enableAutoUpdatesForExtension) {
                        autoUpdateExtensions.splice(autoUpdateExtensions.indexOf(extensionId), 1);
                        update = true;
                    }
                }
                else {
                    if (!enableAutoUpdatesForExtension) {
                        autoUpdateExtensions.push(extensionId);
                        update = true;
                    }
                }
            }
            else {
                if (enableAutoUpdatesForExtension) {
                    autoUpdateExtensions.splice(autoUpdateExtensions.indexOf(extensionId), 1);
                    update = true;
                }
                if (enableAutoUpdatesForPublisher) {
                    if (!disableAutoUpdatesForExtension) {
                        autoUpdateExtensions.push(`-${extensionId}`);
                        update = true;
                    }
                }
                else {
                    if (disableAutoUpdatesForExtension) {
                        autoUpdateExtensions.splice(autoUpdateExtensions.indexOf(`-${extensionId}`), 1);
                        update = true;
                    }
                }
            }
        }
        if (update) {
            this.setSelectedExtensionsToAutoUpdate(autoUpdateExtensions);
            await this.onDidSelectedExtensionToAutoUpdateValueChange(true);
            if (autoUpdateValue === 'onlySelectedExtensions' && autoUpdateExtensions.length === 0) {
                await this.configurationService.updateValue(AutoUpdateConfigurationKey, false);
            }
        }
    }
    async onDidSelectedExtensionToAutoUpdateValueChange(forceUpdate) {
        if (forceUpdate || this.selectedExtensionsToAutoUpdateValue !== this.getSelectedExtensionsToAutoUpdateValue() ) {
            await this.updateExtensionsPinnedState();
            this.eventuallyAutoUpdateExtensions();
        }
    }
    async canInstall(extension) {
        if (!(extension instanceof Extension)) {
            return false;
        }
        if (extension.isMalicious) {
            return false;
        }
        if (extension.deprecationInfo?.disallowInstall) {
            return false;
        }
        if (extension.gallery) {
            if (this.localExtensions && (await this.localExtensions.canInstall(extension.gallery))) {
                return true;
            }
            if (this.remoteExtensions && (await this.remoteExtensions.canInstall(extension.gallery))) {
                return true;
            }
            if (this.webExtensions && (await this.webExtensions.canInstall(extension.gallery))) {
                return true;
            }
            return false;
        }
        if (extension.resourceExtension && (await this.extensionManagementService.canInstall(extension.resourceExtension))) {
            return true;
        }
        return false;
    }
    async install(arg, installOptions = {}, progressLocation) {
        let installable;
        let extension;
        if (arg instanceof URI) {
            installable = arg;
        }
        else {
            let installableInfo;
            let gallery;
            if (isString(arg)) {
                extension = this.local.find(e => areSameExtensions(e.identifier, { id: arg }));
                if (!extension?.isBuiltin) {
                    installableInfo = { id: arg, version: installOptions.version, preRelease: installOptions.installPreReleaseVersion ?? this.preferPreReleases };
                }
            }
            else if (arg.gallery) {
                extension = arg;
                gallery = arg.gallery;
                if (installOptions.version && installOptions.version !== gallery?.version) {
                    installableInfo = { id: extension.identifier.id, version: installOptions.version };
                }
            }
            else if (arg.resourceExtension) {
                extension = arg;
                installable = arg.resourceExtension;
            }
            if (installableInfo) {
                const targetPlatform = extension?.server ? await extension.server.extensionManagementService.getTargetPlatform() : undefined;
                gallery = firstOrDefault(await this.galleryService.getExtensions([installableInfo], { targetPlatform }, CancellationToken.None));
            }
            if (!extension && gallery) {
                extension = this.instantiationService.createInstance(Extension, ext => this.getExtensionState(ext), ext => this.getRuntimeState(ext), undefined, undefined, gallery, undefined);
                Extensions.updateExtensionFromControlManifest(extension, await this.extensionManagementService.getExtensionsControlManifest());
            }
            if (extension?.isMalicious) {
                throw ( (new Error(
                    localizeWithPath(_moduleId, 13, "This extension is reported to be problematic.")
                )));
            }
            if (!(installOptions.enable && extension?.local)) {
                if (!installable) {
                    if (!gallery) {
                        const id = isString(arg) ? arg : arg.identifier.id;
                        if (installOptions.version) {
                            throw ( (new Error(localizeWithPath(
                                _moduleId,
                                14,
                                "Unable to install extension '{0}' because the requested version '{1}' is not found.",
                                id,
                                installOptions.version
                            ))));
                        }
                        else {
                            throw ( (new Error(localizeWithPath(
                                _moduleId,
                                15,
                                "Unable to install extension '{0}' because it is not found.",
                                id
                            ))));
                        }
                    }
                    installable = gallery;
                }
                if (installOptions.version) {
                    installOptions.installGivenVersion = true;
                }
                if (extension?.isWorkspaceScoped) {
                    installOptions.isWorkspaceScoped = true;
                }
            }
        }
        if (installable) {
            if (installOptions.justification) {
                const syncCheck = isUndefined(installOptions.isMachineScoped) && this.userDataSyncEnablementService.isEnabled() && this.userDataSyncEnablementService.isResourceEnabled("extensions" );
                const buttons = [];
                buttons.push({
                    label: isString(installOptions.justification) || !installOptions.justification.action
                        ? ( localizeWithPath(_moduleId, 16, "&&Install Extension"))
                        : ( localizeWithPath(
                        _moduleId,
                        17,
                        "&&Install Extension and {0}",
                        installOptions.justification.action
                    )), run: () => true
                });
                if (!extension) {
                    buttons.push({ label: ( localizeWithPath(_moduleId, 18, "Open Extension")), run: () => { this.open(extension); return false; } });
                }
                const result = await this.dialogService.prompt({
                    title: ( localizeWithPath(_moduleId, 19, "Install Extension")),
                    message: extension ? ( localizeWithPath(
                        _moduleId,
                        20,
                        "Would you like to install '{0}' extension from '{1}'?",
                        extension.displayName,
                        extension.publisherDisplayName
                    )) : ( localizeWithPath(_moduleId, 21, "Would you like to install the extension?")),
                    detail: isString(installOptions.justification) ? installOptions.justification : installOptions.justification.reason,
                    cancelButton: true,
                    buttons,
                    checkbox: syncCheck ? {
                        label: ( localizeWithPath(_moduleId, 22, "Sync this extension")),
                        checked: true,
                    } : undefined,
                });
                if (!result.result) {
                    throw ( (new CancellationError()));
                }
                if (syncCheck) {
                    installOptions.isMachineScoped = !result.checkboxChecked;
                }
            }
            if (installable instanceof URI) {
                extension = await this.doInstall(undefined, () => this.installFromVSIX(installable, installOptions), progressLocation);
            }
            else if (extension) {
                if (extension.resourceExtension) {
                    extension = await this.doInstall(extension, () => this.extensionManagementService.installResourceExtension(installable, installOptions), progressLocation);
                }
                else {
                    extension = await this.doInstall(extension, () => this.installFromGallery(extension, installable, installOptions), progressLocation);
                }
            }
        }
        if (!extension) {
            throw ( (new Error(localizeWithPath(_moduleId, 23, "Unable to install extension"))));
        }
        if (installOptions.version) {
            await this.updateAutoUpdateEnablementFor(extension, false);
        }
        if (installOptions.enable) {
            if (extension.enablementState === 7  || extension.enablementState === 6 ) {
                if (installOptions.justification) {
                    const result = await this.dialogService.confirm({
                        title: ( localizeWithPath(_moduleId, 24, "Enable Extension")),
                        message: ( localizeWithPath(
                            _moduleId,
                            25,
                            "Would you like to enable '{0}' extension?",
                            extension.displayName
                        )),
                        detail: isString(installOptions.justification) ? installOptions.justification : installOptions.justification.reason,
                        primaryButton: isString(installOptions.justification) ? ( localizeWithPath(_moduleId, 26, "&&Enable Extension")) : ( localizeWithPath(
                            _moduleId,
                            27,
                            "&&Enable Extension and {0}",
                            installOptions.justification.action
                        )),
                    });
                    if (!result.confirmed) {
                        throw ( (new CancellationError()));
                    }
                }
                await this.setEnablement(extension, extension.enablementState === 7  ? 9  : 8 );
            }
            await this.waitUntilExtensionIsEnabled(extension);
        }
        return extension;
    }
    async installInServer(extension, server) {
        await this.doInstall(extension, async () => {
            const local = extension.local;
            if (!local) {
                throw ( (new Error('Extension not found')));
            }
            if (!extension.gallery) {
                extension = (await this.getExtensions([{ ...extension.identifier, preRelease: local.preRelease }], CancellationToken.None))[0] ?? extension;
            }
            if (extension.gallery) {
                return server.extensionManagementService.installFromGallery(extension.gallery, { installPreReleaseVersion: local.preRelease });
            }
            const targetPlatform = await server.extensionManagementService.getTargetPlatform();
            if (!isTargetPlatformCompatible(local.targetPlatform, [local.targetPlatform], targetPlatform)) {
                throw ( (new Error(localizeWithPath(
                    _moduleId,
                    28,
                    "Can't install '{0}' extension because it is not compatible.",
                    extension.identifier.id
                ))));
            }
            const vsix = await this.extensionManagementService.zip(local);
            try {
                return await server.extensionManagementService.install(vsix);
            }
            finally {
                try {
                    await this.fileService.del(vsix);
                }
                catch (error) {
                    this.logService.error(error);
                }
            }
        });
    }
    canSetLanguage(extension) {
        if (!isWeb) {
            return false;
        }
        if (!extension.gallery) {
            return false;
        }
        const locale = getLocale(extension.gallery);
        if (!locale) {
            return false;
        }
        return true;
    }
    async setLanguage(extension) {
        if (!this.canSetLanguage(extension)) {
            throw ( (new Error('Can not set language')));
        }
        const locale = getLocale(extension.gallery);
        if (locale === language) {
            return;
        }
        const localizedLanguageName = extension.gallery?.properties?.localizedLanguages?.[0];
        return this.localeService.setLocale({ id: locale, galleryExtension: extension.gallery, extensionId: extension.identifier.id, label: localizedLanguageName ?? extension.displayName });
    }
    setEnablement(extensions, enablementState) {
        extensions = Array.isArray(extensions) ? extensions : [extensions];
        return this.promptAndSetEnablement(extensions, enablementState);
    }
    uninstall(extension) {
        const ext = extension.local ? extension : this.local.filter(e => areSameExtensions(e.identifier, extension.identifier))[0];
        const toUninstall = ext && ext.local ? ext.local : null;
        if (!toUninstall) {
            return Promise.reject(( (new Error('Missing local'))));
        }
        return this.withProgress({
            location: 5 ,
            title: ( localizeWithPath(_moduleId, 29, 'Uninstalling extension....')),
            source: `${toUninstall.identifier.id}`
        }, () => this.extensionManagementService.uninstall(toUninstall).then(() => undefined));
    }
    reinstall(extension) {
        return this.doInstall(extension, () => {
            const ext = extension.local ? extension : this.local.filter(e => areSameExtensions(e.identifier, extension.identifier))[0];
            const toReinstall = ext && ext.local ? ext.local : null;
            if (!toReinstall) {
                throw ( (new Error('Missing local')));
            }
            return this.extensionManagementService.reinstallFromGallery(toReinstall);
        });
    }
    isExtensionIgnoredToSync(extension) {
        return extension.local ? !this.isInstalledExtensionSynced(extension.local)
            : this.extensionsSyncManagementService.hasToNeverSyncExtension(extension.identifier.id);
    }
    async togglePreRelease(extension) {
        if (!extension.local) {
            return;
        }
        if (extension.preRelease !== extension.isPreReleaseVersion) {
            await this.extensionManagementService.updateMetadata(extension.local, { preRelease: !extension.preRelease });
            return;
        }
        await this.install(extension, { installPreReleaseVersion: !extension.preRelease, preRelease: !extension.preRelease });
    }
    async toggleExtensionIgnoredToSync(extension) {
        const isIgnored = this.isExtensionIgnoredToSync(extension);
        if (extension.local && isIgnored) {
            extension.local = await this.updateSynchronizingInstalledExtension(extension.local, true);
            this._onChange.fire(extension);
        }
        else {
            this.extensionsSyncManagementService.updateIgnoredExtensions(extension.identifier.id, !isIgnored);
        }
        await this.userDataAutoSyncService.triggerSync(['IgnoredExtensionsUpdated'], false, false);
    }
    async toggleApplyExtensionToAllProfiles(extension) {
        if (!extension.local || isApplicationScopedExtension(extension.local.manifest) || extension.isBuiltin) {
            return;
        }
        await this.extensionManagementService.toggleAppliationScope(extension.local, this.userDataProfileService.currentProfile.extensionsResource);
    }
    isInstalledExtensionSynced(extension) {
        if (extension.isMachineScoped) {
            return false;
        }
        if (this.extensionsSyncManagementService.hasToAlwaysSyncExtension(extension.identifier.id)) {
            return true;
        }
        return !this.extensionsSyncManagementService.hasToNeverSyncExtension(extension.identifier.id);
    }
    async updateSynchronizingInstalledExtension(extension, sync) {
        const isMachineScoped = !sync;
        if (extension.isMachineScoped !== isMachineScoped) {
            extension = await this.extensionManagementService.updateMetadata(extension, { isMachineScoped });
        }
        if (sync) {
            this.extensionsSyncManagementService.updateIgnoredExtensions(extension.identifier.id, false);
        }
        return extension;
    }
    doInstall(extension, installTask, progressLocation) {
        const title = extension ? ( localizeWithPath(_moduleId, 30, "Installing '{0}' extension....", extension.displayName)) : ( localizeWithPath(_moduleId, 31, 'Installing extension....'));
        return this.withProgress({
            location: progressLocation ?? 5 ,
            title
        }, async () => {
            try {
                if (extension) {
                    this.installing.push(extension);
                    this._onChange.fire(extension);
                }
                const local = await installTask();
                return await this.waitAndGetInstalledExtension(local.identifier);
            }
            finally {
                if (extension) {
                    this.installing = this.installing.filter(e => e !== extension);
                    this._onChange.fire(undefined);
                }
            }
        });
    }
    async installFromVSIX(vsix, installOptions) {
        const manifest = await this.extensionManagementService.getManifest(vsix);
        const existingExtension = this.local.find(local => areSameExtensions(local.identifier, { id: getGalleryExtensionId(manifest.publisher, manifest.name) }));
        if (existingExtension) {
            installOptions = installOptions || {};
            if (existingExtension.latestVersion === manifest.version) {
                installOptions.pinned = existingExtension.local?.pinned || !this.shouldAutoUpdateExtension(existingExtension);
            }
            else {
                installOptions.installGivenVersion = true;
            }
        }
        return this.extensionManagementService.installVSIX(vsix, manifest, installOptions);
    }
    installFromGallery(extension, gallery, installOptions) {
        installOptions = installOptions ?? {};
        installOptions.pinned = extension.local?.pinned || !this.shouldAutoUpdateExtension(extension);
        if (extension.local) {
            installOptions.productVersion = this.getProductVersion();
            return this.extensionManagementService.updateFromGallery(gallery, extension.local, installOptions);
        }
        else {
            return this.extensionManagementService.installFromGallery(gallery, installOptions);
        }
    }
    async waitAndGetInstalledExtension(identifier) {
        let installedExtension = this.local.find(local => areSameExtensions(local.identifier, identifier));
        if (!installedExtension) {
            await Event.toPromise(Event.filter(this.onChange, e => !!e && ( (this.local.some(local => areSameExtensions(local.identifier, identifier))))));
        }
        installedExtension = this.local.find(local => areSameExtensions(local.identifier, identifier));
        if (!installedExtension) {
            throw ( (new Error('Extension should have been installed')));
        }
        return installedExtension;
    }
    async waitUntilExtensionIsEnabled(extension) {
        if (this.extensionService.extensions.find(e => ExtensionIdentifier.equals(e.identifier, extension.identifier.id))) {
            return;
        }
        if (!extension.local || !this.extensionService.canAddExtension(toExtensionDescription(extension.local))) {
            return;
        }
        await ( (new Promise((c, e) => {
            const disposable = this.extensionService.onDidChangeExtensions(() => {
                try {
                    if (this.extensionService.extensions.find(e => ExtensionIdentifier.equals(e.identifier, extension.identifier.id))) {
                        disposable.dispose();
                        c();
                    }
                }
                catch (error) {
                    e(error);
                }
            });
        })));
    }
    promptAndSetEnablement(extensions, enablementState) {
        const enable = enablementState === 8  || enablementState === 9 ;
        if (enable) {
            const allDependenciesAndPackedExtensions = this.getExtensionsRecursively(extensions, this.local, enablementState, { dependencies: true, pack: true });
            return this.checkAndSetEnablement(extensions, allDependenciesAndPackedExtensions, enablementState);
        }
        else {
            const packedExtensions = this.getExtensionsRecursively(extensions, this.local, enablementState, { dependencies: false, pack: true });
            if (packedExtensions.length) {
                return this.checkAndSetEnablement(extensions, packedExtensions, enablementState);
            }
            return this.checkAndSetEnablement(extensions, [], enablementState);
        }
    }
    checkAndSetEnablement(extensions, otherExtensions, enablementState) {
        const allExtensions = [...extensions, ...otherExtensions];
        const enable = enablementState === 8  || enablementState === 9 ;
        if (!enable) {
            for (const extension of extensions) {
                const dependents = this.getDependentsAfterDisablement(extension, allExtensions, this.local);
                if (dependents.length) {
                    return (
                         (new Promise((resolve, reject) => {
                            this.notificationService.prompt(Severity$1.Error, this.getDependentsErrorMessage(extension, allExtensions, dependents), [
                                {
                                    label: ( localizeWithPath(_moduleId, 32, 'Disable All')),
                                    run: async () => {
                                        try {
                                            await this.checkAndSetEnablement(dependents, [extension], enablementState);
                                            resolve();
                                        }
                                        catch (error) {
                                            reject(error);
                                        }
                                    }
                                }
                            ], {
                                onCancel: () => reject(( (new CancellationError())))
                            });
                        }))
                    );
                }
            }
        }
        return this.doSetEnablement(allExtensions, enablementState);
    }
    getExtensionsRecursively(extensions, installed, enablementState, options, checked = []) {
        const toCheck = extensions.filter(e => checked.indexOf(e) === -1);
        if (toCheck.length) {
            for (const extension of toCheck) {
                checked.push(extension);
            }
            const extensionsToEanbleOrDisable = installed.filter(i => {
                if (checked.indexOf(i) !== -1) {
                    return false;
                }
                const enable = enablementState === 8  || enablementState === 9 ;
                const isExtensionEnabled = i.enablementState === 8  || i.enablementState === 9 ;
                if (enable === isExtensionEnabled) {
                    return false;
                }
                return (enable || !i.isBuiltin)
                    && (options.dependencies || options.pack)
                    && ( (extensions.some(
                    extension => (options.dependencies && ( (extension.dependencies.some(id => areSameExtensions({ id }, i.identifier)))))
                            || (options.pack && ( (extension.extensionPack.some(id => areSameExtensions({ id }, i.identifier)))))
                )));
            });
            if (extensionsToEanbleOrDisable.length) {
                extensionsToEanbleOrDisable.push(...this.getExtensionsRecursively(extensionsToEanbleOrDisable, installed, enablementState, options, checked));
            }
            return extensionsToEanbleOrDisable;
        }
        return [];
    }
    getDependentsAfterDisablement(extension, extensionsToDisable, installed) {
        return installed.filter(i => {
            if (i.dependencies.length === 0) {
                return false;
            }
            if (i === extension) {
                return false;
            }
            if (!this.extensionEnablementService.isEnabledEnablementState(i.enablementState)) {
                return false;
            }
            if (extensionsToDisable.indexOf(i) !== -1) {
                return false;
            }
            return (
                 (i.dependencies.some(
                    dep => ( ([extension, ...extensionsToDisable].some(d => areSameExtensions(d.identifier, { id: dep }))))
                ))
            );
        });
    }
    getDependentsErrorMessage(extension, allDisabledExtensions, dependents) {
        for (const e of [extension, ...allDisabledExtensions]) {
            const dependentsOfTheExtension = dependents.filter(d => ( (d.dependencies.some(id => areSameExtensions({ id }, e.identifier)))));
            if (dependentsOfTheExtension.length) {
                return this.getErrorMessageForDisablingAnExtensionWithDependents(e, dependentsOfTheExtension);
            }
        }
        return '';
    }
    getErrorMessageForDisablingAnExtensionWithDependents(extension, dependents) {
        if (dependents.length === 1) {
            return ( localizeWithPath(
                _moduleId,
                33,
                "Cannot disable '{0}' extension alone. '{1}' extension depends on this. Do you want to disable all these extensions?",
                extension.displayName,
                dependents[0].displayName
            ));
        }
        if (dependents.length === 2) {
            return ( localizeWithPath(
                _moduleId,
                34,
                "Cannot disable '{0}' extension alone. '{1}' and '{2}' extensions depend on this. Do you want to disable all these extensions?",
                extension.displayName,
                dependents[0].displayName,
                dependents[1].displayName
            ));
        }
        return ( localizeWithPath(
            _moduleId,
            35,
            "Cannot disable '{0}' extension alone. '{1}', '{2}' and other extensions depend on this. Do you want to disable all these extensions?",
            extension.displayName,
            dependents[0].displayName,
            dependents[1].displayName
        ));
    }
    async doSetEnablement(extensions, enablementState) {
        const changed = await this.extensionEnablementService.setEnablement(( (extensions.map(e => e.local))), enablementState);
        for (let i = 0; i < changed.length; i++) {
            if (changed[i]) {
                this.telemetryService.publicLog(enablementState === 8  || enablementState === 9  ? 'extension:enable' : 'extension:disable', extensions[i].telemetryData);
            }
        }
        return changed;
    }
    reportProgressFromOtherSources() {
        if (( (this.installed.some(
            e => e.state === 0  || e.state === 2
        )))) {
            if (!this._activityCallBack) {
                this.withProgress({ location: 5  }, () => ( (new Promise(resolve => this._activityCallBack = resolve))));
            }
        }
        else {
            this._activityCallBack?.();
            this._activityCallBack = undefined;
        }
    }
    withProgress(options, task) {
        return this.progressService.withProgress(options, async () => {
            const cancelableTask = createCancelablePromise(() => task());
            this.tasksInProgress.push(cancelableTask);
            try {
                return await cancelableTask;
            }
            finally {
                const index = this.tasksInProgress.indexOf(cancelableTask);
                if (index !== -1) {
                    this.tasksInProgress.splice(index, 1);
                }
            }
        });
    }
    onError(err) {
        if (isCancellationError(err)) {
            return;
        }
        const message = err && err.message || '';
        if (/getaddrinfo ENOTFOUND|getaddrinfo ENOENT|connect EACCES|connect ECONNREFUSED/.test(message)) {
            return;
        }
        this.notificationService.error(err);
    }
    handleURL(uri, options) {
        if (!/^extension/.test(uri.path)) {
            return Promise.resolve(false);
        }
        this.onOpenExtensionUrl(uri);
        return Promise.resolve(true);
    }
    onOpenExtensionUrl(uri) {
        const match = /^extension\/([^/]+)$/.exec(uri.path);
        if (!match) {
            return;
        }
        const extensionId = match[1];
        this.queryLocal().then(async (local) => {
            let extension = local.find(local => areSameExtensions(local.identifier, { id: extensionId }));
            if (!extension) {
                [extension] = await this.getExtensions([{ id: extensionId }], { source: 'uri' }, CancellationToken.None);
            }
            if (extension) {
                await this.hostService.focus(mainWindow);
                await this.open(extension);
            }
        }).then(undefined, error => this.onError(error));
    }
    getPublishersToAutoUpdate() {
        return this.getSelectedExtensionsToAutoUpdate().filter(id => !EXTENSION_IDENTIFIER_REGEX.test(id));
    }
    getSelectedExtensionsToAutoUpdate() {
        try {
            const parsedValue = JSON.parse(this.selectedExtensionsToAutoUpdateValue);
            if (Array.isArray(parsedValue)) {
                return parsedValue;
            }
        }
        catch (e) {  }
        return [];
    }
    setSelectedExtensionsToAutoUpdate(selectedExtensionsToAutoUpdate) {
        this.selectedExtensionsToAutoUpdateValue = JSON.stringify(selectedExtensionsToAutoUpdate);
    }
    get selectedExtensionsToAutoUpdateValue() {
        if (!this._selectedExtensionsToAutoUpdateValue) {
            this._selectedExtensionsToAutoUpdateValue = this.getSelectedExtensionsToAutoUpdateValue();
        }
        return this._selectedExtensionsToAutoUpdateValue;
    }
    set selectedExtensionsToAutoUpdateValue(placeholderViewContainesValue) {
        if (this.selectedExtensionsToAutoUpdateValue !== placeholderViewContainesValue) {
            this._selectedExtensionsToAutoUpdateValue = placeholderViewContainesValue;
            this.setSelectedExtensionsToAutoUpdateValue(placeholderViewContainesValue);
        }
    }
    getSelectedExtensionsToAutoUpdateValue() {
        return this.storageService.get(EXTENSIONS_AUTO_UPDATE_KEY, -1 , '[]');
    }
    setSelectedExtensionsToAutoUpdateValue(value) {
        this.storageService.store(EXTENSIONS_AUTO_UPDATE_KEY, value, -1 , 0 );
    }
};
ExtensionsWorkbenchService = ExtensionsWorkbenchService_1 = ( (__decorate([
    ( (__param(0, IInstantiationService))),
    ( (__param(1, IEditorService))),
    ( (__param(2, IWorkbenchExtensionManagementService))),
    ( (__param(3, IExtensionGalleryService))),
    ( (__param(4, IConfigurationService))),
    ( (__param(5, ITelemetryService))),
    ( (__param(6, INotificationService))),
    ( (__param(7, IURLService))),
    ( (__param(8, IWorkbenchExtensionEnablementService))),
    ( (__param(9, IHostService))),
    ( (__param(10, IProgressService))),
    ( (__param(11, IExtensionManagementServerService))),
    ( (__param(12, ILanguageService))),
    ( (__param(13, IIgnoredExtensionsManagementService))),
    ( (__param(14, IUserDataAutoSyncService))),
    ( (__param(15, IProductService))),
    ( (__param(16, IContextKeyService))),
    ( (__param(17, IExtensionManifestPropertiesService))),
    ( (__param(18, ILogService))),
    ( (__param(19, IExtensionService))),
    ( (__param(20, ILocaleService))),
    ( (__param(21, ILifecycleService))),
    ( (__param(22, IFileService))),
    ( (__param(23, IUserDataProfileService))),
    ( (__param(24, IStorageService))),
    ( (__param(25, IDialogService))),
    ( (__param(26, IUserDataSyncEnablementService))),
    ( (__param(27, IUpdateService))),
    ( (__param(28, IUriIdentityService))),
    ( (__param(29, IWorkspaceContextService)))
], ExtensionsWorkbenchService)));

export { Extension, ExtensionsWorkbenchService };
